module.exports = __webpack_public_path__ + "static/media/close.647963f2.svg";